import * as PIXI from 'pixi.js';
import type { UpdateFlowMixinSettings } from '../updateFlowMixin';
import { TypedUpdateFlowMixin } from '../updateFlowMixin';
import { ColorAttribute } from '../attributes';
import type { SerializableMixinSettings } from '../serializableMixin';
import { TypedSerializableMixin } from '../serializableMixin';
import type { BaseAsset } from '../asset/BaseAsset';

type AssetAnchorHelperSettings = {
    strokeColor?: number;
    asset: BaseAsset;
    referenceToOutputMultiplier?: number;
} & UpdateFlowMixinSettings &
    SerializableMixinSettings;

export class AssetAnchorDisplay extends TypedUpdateFlowMixin(
    TypedSerializableMixin(PIXI.Graphics),
) {
    override name = 'assetAnchorDisplay';
    @ColorAttribute()
    accessor strokeColor = 0;
    #strokeWidthInOutputResolution = 3;
    asset: BaseAsset = undefined;
    #referenceToOutputMultiplier: number;

    constructor(settings: AssetAnchorHelperSettings) {
        super(settings);
        this.strokeColor = settings.strokeColor ?? this.strokeColor;
        this.asset = settings.asset;
        this.#referenceToOutputMultiplier = settings.referenceToOutputMultiplier ?? 1;
    }

    override _update() {
        if (!this.asset) {
            return;
        }
        this.clear();
        const { x, y } = this.asset._pixiContainer.getBounds();
        const segment = 50;
        const halfSegment = segment / 2;
        const strokeWidth = Math.max(
            1,
            Math.round(this.#strokeWidthInOutputResolution / this.#referenceToOutputMultiplier),
        );
        this.lineStyle(strokeWidth, this.strokeColor, 1);
        this.moveTo(x - halfSegment, y);
        this.lineTo(x + halfSegment, y);
        this.moveTo(x, y - halfSegment);
        this.lineTo(x, y + halfSegment);
    }
}
